module.exports = __webpack_public_path__ + "img/tab42.03bb9e37.png";